import React, { useState } from 'react';
import { addCrmLeadComment } from '../config/api';

const CrmCommentDialog = ({
  leadId,
  allowFollowUp = false,
  onClose,
  onSaved,
}) => {
  const [comment, setComment] = useState('');
  const [followUpDate, setFollowUpDate] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    const value = comment.trim();
    if (!value) {
      setError('Enter a comment before saving.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      await addCrmLeadComment(leadId, value, allowFollowUp ? followUpDate : '');
      if (onSaved) await onSaved();
      onClose();
    } catch (err) {
      setError(err.message || 'Could not add the comment.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h3>Add comment</h3>
          <button className="modal-close" onClick={onClose} disabled={saving}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label" htmlFor="crm-lead-comment">Comment</label>
            <textarea
              id="crm-lead-comment"
              className="form-control"
              rows={5}
              maxLength={5000}
              autoFocus
              placeholder="Add context or the next action for this lead"
              value={comment}
              onChange={(event) => {
                setComment(event.target.value);
                if (error) setError('');
              }}
              disabled={saving}
            />
            <div className="crm-muted" style={{ marginTop: '6px' }}>
              {comment.length}/5000 characters
            </div>
            {error && <div className="crm-form-error">{error}</div>}
          </div>
          {allowFollowUp && (
            <div className="form-group">
              <label className="form-label" htmlFor="crm-lead-comment-follow-up">
                Follow-up date <span className="crm-muted">(optional)</span>
              </label>
              <input
                id="crm-lead-comment-follow-up"
                type="date"
                className="form-control"
                value={followUpDate}
                onChange={(event) => {
                  setFollowUpDate(event.target.value);
                  if (error) setError('');
                }}
                disabled={saving}
              />
              <div className="crm-muted" style={{ marginTop: '6px' }}>
                The current time will be saved automatically with the selected date.
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={save} disabled={saving || !comment.trim()}>
            {saving ? 'Saving…' : 'Save comment'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmCommentDialog;
